// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import inquiryDeadlineEntity from './entities/inquiry-deadline.json';
import inquiryDeadlineMenu from '../pages/inquiry-deadline/menu.json';
import inquiryDeadlineFullForm from '../pages/inquiry-deadline/forms/full.json';
import inquiryDeadlineContextForm from '../pages/inquiry-deadline/forms/context.json';
import inquiryDeadlineMiniForm from '../pages/inquiry-deadline/forms/mini.json';
import inquiryDeadlineLookupForm from '../pages/inquiry-deadline/forms/lookup.json';
import inquiryDeadlineTableView from '../pages/inquiry-deadline/views/table.json';
import inquiryDeadlineCardsView from '../pages/inquiry-deadline/views/cards.json';
import inquiryDeadlineCalendarView from '../pages/inquiry-deadline/views/calendar.json';
import inquiryDeadlineDashboardView from '../pages/inquiry-deadline/views/dashboard.json';

/** Тип запису «Строк відповіді» зі сторінками пакета: меню, форми та подання з pages/inquiry-deadline/. */
export const inquiryDeadlineDefinition: IRecordTypeDefinition = {
  ...inquiryDeadlineEntity,
  views: assembleViewSet({
      table: inquiryDeadlineTableView,
      cards: inquiryDeadlineCardsView,
      calendar: inquiryDeadlineCalendarView,
      dashboard: inquiryDeadlineDashboardView,
  }),
  form: inquiryDeadlineFullForm,
  forms: { full: inquiryDeadlineFullForm, context: inquiryDeadlineContextForm, mini: inquiryDeadlineMiniForm, lookup: inquiryDeadlineLookupForm },
  menu: inquiryDeadlineMenu,
} as IRecordTypeDefinition;
